import styled from '@xstyled/styled-components';
import Plus from '~/assets/icons/hotspot-symbol-plus.svg';

/** Figma Icon/plus (~16.5px glyph) for text-only hotspot Symbol mode. */
export const HotspotPlusIcon = styled(Plus)`
  width: 17px;
  height: 17px;
  /* Theme token: light mode dark glyph; dark mode flips via --color-black. */
  color: black;
  flex-shrink: 0;
  display: block;
`;
